import { Tooltip } from '@mui/material';
import React from 'react';

type P = {
  title: string;
  children: React.ReactNode;
};

const CustomToolTip = ({ title, children }: P) => (
  <Tooltip
    title={title}
    placement="top"
    arrow
    slotProps={{
      tooltip: { sx: { backgroundColor: 'black', color: 'white' } },
      arrow: { sx: { color: 'var(--dk-text, black)' } },
      popper: {
        modifiers: [{ name: 'offset', options: { offset: [0, -8] } }],
      },
    }}
  >
    <div>{children}</div>
  </Tooltip>
);
export default CustomToolTip;
